import * as types from '../types'

export const requestMatchesList = () => ({ type: types.MATCHES_LIST_REQUEST })

export const receiveMatchesList = (data: []) => ({
  type: types.MATCHES_LIST_RECEIVE,
  payload: data
})

export const failureMatchesList = (err: any) => ({
  type: types.MATCHES_LIST_FAILURE,
  payload: { err }
})

export const clearMatchesList = () => ({ type: types.MATCHES_LIST_CLEAR })

